'use client'

import cn from 'clsx'
import { useWindowSize } from 'hamo'
import { useGlobalPageTransition } from '~/components/page-transition/context'
import { useDeviceDetection } from '~/hooks/use-device-detection'
import { desktopVW, mobileVW } from '~/libs/utils'
import s from './global-transition.module.css'
import { onAfterEnter, onBeforeEnter, onBeforeExit } from './transition'

const globalTransitionPages = [
  '/',
  '/work',
  '/about',
  '/read',
  '/store',
  '/contact',
]

export function GlobalTransition() {
  const { height: windowHeight = 0, width: windowWidth = 0 } = useWindowSize()
  const { isDesktop } = useDeviceDetection()

  const textlinesCount = Math.ceil(
    isDesktop
      ? windowHeight / desktopVW(106, windowWidth)
      : windowHeight / mobileVW(80, windowWidth)
  )

  const textlines = Array.from({ length: textlinesCount }, (_, i) => i)

  useGlobalPageTransition({
    onBeforeExit,
    onBeforeEnter,
    onAfterEnter,
    pages: globalTransitionPages,
  })

  return (
    <div
      id="curtain"
      className={cn(
        s.container,
        'fixed inset-0 z-50 pointer-events-none banner overflow-hidden flex items-end'
      )}
    >
      <div
        id="curtain-content"
        className="relative px-safe flex flex-col sgap-10 dt:sgap-20 dt:spt-20 min-h-screen w-full"
        suppressHydrationWarning
      >
        <div
          id="curtain-content-bg"
          className={cn(s.background, 'absolute inset-0 bg-primary')}
        />
        {textlines.map((line, idx) => (
          <p
            key={`curtain-text-line-${textlinesCount}-${line}`}
            className={cn(
              'relative flex whitespace-nowrap',
              idx !== textlines.length - 1 && 'curtain-text-line',
              textlines.length % 2 === 0
                ? idx % 2 === 0
                  ? 'curtain-text-line-right'
                  : 'curtain-text-line-left'
                : idx % 2 === 0
                  ? 'curtain-text-line-left'
                  : 'curtain-text-line-right'
            )}
          >
            <span className="absolute right-full curtain-line dt:smr-200" />
            <span className="curtain-line dt:smr-200" />
            <span className="curtain-line dt:smr-200" />
          </p>
        ))}
      </div>
    </div>
  )
}
